module.exports = __webpack_public_path__ + "img/lucky5ex_icon.1b67e15e.png";